import { isAfter, startOfDay } from 'date-fns';
import { StageScheduleContext } from '../OneTimeInStagesModel';
export const resolveStageScheduleContext = (params)=>{
    if (params.isTemplate) return StageScheduleContext.Template;
    if (params.isAmendment) return StageScheduleContext.Amendment;
    if (params.effectiveDate && isAfter(startOfDay(params.effectiveDate), startOfDay(params.now))) {
        return StageScheduleContext.ProposalOnEffectiveDate;
    }
    return StageScheduleContext.ProposalOnAcceptance;
};
